import React from "react"
import { Container } from "@material-ui/core"
import Layout from "../components/layout"
import SEO from "../components/seo"

const TOSPage = () => (
  <Layout>
    <SEO title="Rugby Moments Terms of Service" />
    <Container component="main" maxWidth="md">
      <br />
      <h3>Rugby Moments Terms of Service</h3>
      <p>
        TBC. 
      </p>
    </Container>
  </Layout>
)

export default TOSPage
